export interface DermDiagnosis {
  label: string
  category: string
}

export const dermDiagnoses: DermDiagnosis[] = [
  // Acne
  { label: 'Acne vulgaris', category: 'Acne' },
  { label: 'Cystic acne', category: 'Acne' },
  { label: 'Hormonal acne', category: 'Acne' },
  { label: 'Comedonal acne', category: 'Acne' },
  { label: 'Acne rosacea', category: 'Acne' },

  // Eczema / Dermatitis
  { label: 'Atopic dermatitis', category: 'Eczema' },
  { label: 'Contact dermatitis', category: 'Eczema' },
  { label: 'Seborrheic dermatitis', category: 'Eczema' },
  { label: 'Nummular eczema', category: 'Eczema' },
  { label: 'Dyshidrotic eczema', category: 'Eczema' },
  { label: 'Stasis dermatitis', category: 'Eczema' },

  // Psoriasis
  { label: 'Plaque psoriasis', category: 'Psoriasis' },
  { label: 'Guttate psoriasis', category: 'Psoriasis' },
  { label: 'Inverse psoriasis', category: 'Psoriasis' },
  { label: 'Pustular psoriasis', category: 'Psoriasis' },
  { label: 'Scalp psoriasis', category: 'Psoriasis' },
  { label: 'Nail psoriasis', category: 'Psoriasis' },
  { label: 'Psoriatic arthritis', category: 'Psoriasis' },

  // Rosacea
  { label: 'Erythematotelangiectatic rosacea', category: 'Rosacea' },
  { label: 'Papulopustular rosacea', category: 'Rosacea' },
  { label: 'Phymatous rosacea', category: 'Rosacea' },
  { label: 'Ocular rosacea', category: 'Rosacea' },

  // Skin Cancer
  { label: 'Basal cell carcinoma', category: 'Skin Cancer' },
  { label: 'Squamous cell carcinoma', category: 'Skin Cancer' },
  { label: 'Melanoma', category: 'Skin Cancer' },
  { label: 'Actinic keratosis', category: 'Skin Cancer' },
  { label: 'Melanoma in situ', category: 'Skin Cancer' },

  // Moles & Nevi
  { label: 'Atypical mole (dysplastic nevus)', category: 'Moles & Nevi' },
  { label: 'Benign nevus', category: 'Moles & Nevi' },
  { label: 'Congenital nevus', category: 'Moles & Nevi' },

  // Infections
  { label: 'Fungal infection (tinea)', category: 'Infections' },
  { label: 'Bacterial skin infection', category: 'Infections' },
  { label: 'Viral warts', category: 'Infections' },
  { label: 'Herpes simplex', category: 'Infections' },
  { label: 'Herpes zoster (shingles)', category: 'Infections' },
  { label: 'Cellulitis', category: 'Infections' },
  { label: 'Impetigo', category: 'Infections' },
  { label: 'Molluscum contagiosum', category: 'Infections' },

  // Pigmentation
  { label: 'Melasma', category: 'Pigmentation' },
  { label: 'Vitiligo', category: 'Pigmentation' },
  { label: 'Post-inflammatory hyperpigmentation', category: 'Pigmentation' },
  { label: 'Post-inflammatory hypopigmentation', category: 'Pigmentation' },
  { label: 'Solar lentigines', category: 'Pigmentation' },

  // Hair
  { label: 'Androgenetic alopecia', category: 'Hair' },
  { label: 'Alopecia areata', category: 'Hair' },
  { label: 'Telogen effluvium', category: 'Hair' },
  { label: 'Traction alopecia', category: 'Hair' },
  { label: 'Scarring alopecia', category: 'Hair' },

  // Urticaria
  { label: 'Acute urticaria', category: 'Urticaria' },
  { label: 'Chronic urticaria', category: 'Urticaria' },
  { label: 'Angioedema', category: 'Urticaria' },

  // Benign Growths
  { label: 'Seborrheic keratosis', category: 'Benign Growths' },
  { label: 'Skin tag (acrochordon)', category: 'Benign Growths' },
  { label: 'Dermatofibroma', category: 'Benign Growths' },
  { label: 'Lipoma', category: 'Benign Growths' },
  { label: 'Epidermoid cyst', category: 'Benign Growths' },
  { label: 'Cherry angioma', category: 'Benign Growths' },
  { label: 'Keloid', category: 'Benign Growths' },

  // Autoimmune
  { label: 'Lupus (cutaneous)', category: 'Autoimmune' },
  { label: 'Dermatomyositis', category: 'Autoimmune' },
  { label: 'Morphea', category: 'Autoimmune' },
  { label: 'Lichen planus', category: 'Autoimmune' },
  { label: 'Lichen sclerosus', category: 'Autoimmune' },

  // Other
  { label: 'Pruritus (itching), unspecified', category: 'Other' },
  { label: 'Dry skin (xerosis)', category: 'Other' },
  { label: 'Hyperhidrosis', category: 'Other' },
  { label: 'Drug eruption', category: 'Other' },
  { label: 'Granuloma annulare', category: 'Other' },
  { label: 'Perioral dermatitis', category: 'Other' },
  { label: 'Hidradenitis suppurativa', category: 'Other' },
]
